var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { State, Action, Selector } from '@ngxs/store';
import { SetTheme, ResetLayout } from './layout.actions';
import { LayoutStateModel } from './layout.state.model';
import { LayoutThemeEnum } from '../models/layout-theme.enum';
var initialState = {
    theme: LayoutThemeEnum.Light
};
var LayoutState = /** @class */ (function () {
    function LayoutState() {
    }
    LayoutState.getTheme = function (state) {
        return state.theme;
    };
    LayoutState.prototype.setTheme = function (_a, _b) {
        var patchState = _a.patchState;
        var theme = _b.theme;
        patchState({
            theme: theme
        });
    };
    LayoutState.prototype.resetLayout = function (context, action) {
        context.setState(initialState);
    };
    __decorate([
        Action(SetTheme),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SetTheme]),
        __metadata("design:returntype", void 0)
    ], LayoutState.prototype, "setTheme", null);
    __decorate([
        Action(ResetLayout),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ResetLayout]),
        __metadata("design:returntype", void 0)
    ], LayoutState.prototype, "resetLayout", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [LayoutStateModel]),
        __metadata("design:returntype", void 0)
    ], LayoutState, "getTheme", null);
    LayoutState = __decorate([
        State({
            name: 'layout',
            defaults: initialState
        })
    ], LayoutState);
    return LayoutState;
}());
export { LayoutState };
